import {Component, OnInit} from '@angular/core';
import {NodeBuilder} from '../../../../../../../shared/models';
import {ChatDesk, NODE_TYPE} from './chatdesk';
import {FlowManagerService} from '../../../../../services/flow-manager.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {tap} from 'rxjs/internal/operators';

@Component({
    selector: 'app-chatdesk',
    templateUrl: './chatdesk.component.html',
    styleUrls: ['./chatdesk.component.scss'],
})
export class ChatdeskComponent extends NodeBuilder implements OnInit {

    chatDesk: ChatDesk;
    loading = true;

    chatDeskDepartments$: Observable<{ id: string, name: string }[]>;
    chatDeskIntegrations$: Observable<{ sandbox: string[], production: string[] }>;

    constructor(private flowManagerService: FlowManagerService) {
        super(NODE_TYPE);
    }

    ngOnInit(): void {
        this.chatDesk = new ChatDesk();

        this.chatDeskDepartments$ = this.flowManagerService.getChatDeskDepartments().pipe(
            map((departments: {}) =>
                Object.values(departments).map(department => ({
                    id: department['id'],
                    name: department['name'],
                })),
            ),
        );

        this.chatDeskIntegrations$ = this.flowManagerService.getChatDeskIntegrations().pipe(
            map((integrations: { channelTypeId, apiToken, sandbox?, production? }[]) => {
                const sandbox: string[] = [];
                const production: string[] = [];

                for (const integration of integrations) {

                    if (integration.sandbox) {
                        sandbox.push(integration.apiToken);
                        continue;
                    }

                    if (integration.production) {
                        production.push(integration.apiToken);
                    }
                }

                return {
                    sandbox,
                    production,
                };
            }),
            tap(() => this.loading = false)
        );
    }

    set buildForm(stepData: any) {
        this.formGroup = this.chatDesk.toForm(stepData, this.canEdit);
        this.setAllNextStepValues = ['next', 'error'];
    }

    get getStepData(): {} {
        this.chatDesk.setNodeData(this.formGroup.getRawValue());
        return this.chatDesk.nodeData;
    }

    get isNodeValid(): boolean {
        return this.isValidateForm() && !this.loading;
    }
}
